import React, { useEffect, useState } from 'react'
import { makeStyles } from '@mui/styles'
import { find } from 'lodash'

import lang from 'lang'
import { ModalSmall } from '@/modules/base/components/modal/index'
import { CancelButton, ButtonIconSquare } from '@/modules/base/components/buttons'
import Loader from '@/modules/base/components/loader/loader'

import IconCheck from 'assets/images/icons/check.svg'
import { BankingService } from '../services/index'
import { RadioInput } from '@/modules/base/components/inputs'

const ChangeTanModal = (props) => {
  const { transaction, processId, onAbort, onError, onSuccess } = props
  const classes = useStyles(props)
  const [loading, setLoading] = useState(false)
  const [securityFunction, setSecurityFunction] = useState(null)

  useEffect(() => {
    const { meta: { contactData: { securityFunction } } } = transaction
    setSecurityFunction(securityFunction)
  }, [])

  const onCancel = () => { onAbort() }
  const onConfirm = () => {
    const { provideContactChangeRequest: { token }, meta } = transaction
    const requestData = {
      ...meta,
      securityFunction,
    }
    BankingService.psd2.callbacks.contactChange(token, requestData, processId)
      .then(() => {
        setLoading(false)
        onSuccess(transaction)
      })
      .catch(onError)
  }

  const onRadioButtonChange = (value, name) => {
    const { meta: { contactData: { availableSecurityFunctions } } } = transaction
    const newSecurityFunction = find(availableSecurityFunctions, { value })
    setSecurityFunction(newSecurityFunction)
  }

  const onSubmit = () => {
    event.preventDefault()
    setLoading(true)
    onConfirm()
  }

  const buttons = [
    <CancelButton
      key='cancel'
      type='cancel'
      label={lang.cancelButtonLabel}
      onClick={onCancel} />,
    <ButtonIconSquare
      key='confirm'
      customClass={classes.actionButton}
      type='submit'
      icon={IconCheck}
      label={lang.confirmButtonLabel}
      onClick={onConfirm} />,
  ]

  const { meta: { contactData: { availableSecurityFunctions, securityFunction: actualSecurityFunction } } } = transaction
  const radioOptions = availableSecurityFunctions.map((securityFn) => {
    const { value, description } = securityFn
    return {
      label: description,
      value,
    }
  })

  return (
    <ModalSmall
      title='TAN-Verfahren wechseln'
      subtitle='Bitte wähle ein TAN-Verfahren'
      actions={buttons}
      disableEscapeKeyDown
      disableBackdropClick
      open={true}
      onClose={onCancel}>
      <Loader customClass={classes.loader}
        text="Lädt..."
        visible={loading} />
      <form className={classes.form} onSubmit={onSubmit}>
        <RadioInput
          customClass={classes.radio}
          customOptionClass={classes.option}
          customOptionContainerClass={classes.optionsContainer}
          name='changeTanProcedure'
          options={radioOptions}
          value={actualSecurityFunction.value}
          onChange={onRadioButtonChange}
        />
      </form>
    </ModalSmall>
  )
}

const useStyles = makeStyles(() => ({
  form: {
    marginTop: '30px',
    paddingBottom: '60px',
  },
  actionButton: {
    marginLeft: '15px',
  },
  loader: {
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.9)',
  },
  radio: {
    width: '100%',
  },
  option: {
    border: '1px solid var(--color-border)',
    'border-radius': '4px',
    display: 'flex',
    'justify-content': 'flex-start',
    'align-items': 'center',
    height: '65px',
    width: '100%',
    padding: '0 20px',
    'margin-bottom': '20px',

    /* TODO: dirty solution, better would be global .checked class on option element */
    '& > input:checked': {
      '& ~ span': {
        color: 'var(--color-primary)',
      },
    },
  },
  optionsContainer: {
    display: 'flex',
    'flex-direction': 'column',
    'justify-content': 'flex-start',
    'align-items': 'flex-start',
  },
}))

export default ChangeTanModal
